import React from "react";
import { AiOutlineRight } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import "../../container.css";

export default function AnnouncementTab({ name, desc, link }) {
  const history = useHistory();
  return (
    <div
      className="mb-8 border-b-2 cursor-pointer"
      onClick={() => history.push(link)}
    >
      <div className="flex m-4">
        <div className="px-2">
          <div className="font-bold">{name}</div>
          {/* <div className="text-sm two_line ">{desc}</div> */}
        </div>
        <div className="mt-auto mb-auto ml-auto">
          <AiOutlineRight />
        </div>
      </div>
    </div>
  );
}
